import { CornerLeftUp, Lock, LockKeyhole, type LucideIcon, PenLine } from "lucide-react";

export type Provenance = "overridden" | "inherited" | "lockedAbove" | "locksBelow";

/** One mark: what it says and its icon. Never colour: the word carries the meaning. */
export interface ProvenanceInfo {
  kind: Provenance;
  label: string;
}

const ICONS: Readonly<Record<Provenance, LucideIcon>> = {
  overridden: PenLine,
  inherited: CornerLeftUp,
  lockedAbove: Lock,
  locksBelow: LockKeyhole,
};

/** A provenance mark: the neutral chip vocabulary (sunken, hairline), an icon and a word. */
export function ProvenanceMark({ mark }: { mark: ProvenanceInfo }) {
  const Icon = ICONS[mark.kind];
  return (
    <span
      data-provenance={mark.kind}
      title={mark.label}
      className="inline-flex h-5 max-w-full items-center gap-1 rounded-[5px] border border-line bg-surface-sunken px-1.5 text-xs font-medium text-fg-secondary"
    >
      <Icon aria-hidden="true" className="size-3 shrink-0" strokeWidth={1.75} />
      <span className="truncate">{mark.label}</span>
    </span>
  );
}
